
import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';

import {ProviderAPI} from 'api';
import UseMyLocation from 'components/location/UseMyLocation';

const useStyles = makeStyles(theme => ({
  title : {
    color: theme.palette.common.nightBlue,
    marginBottom: '10px',
  },
  useMyLocation: {
    marginTop: '10px',
  }
}));

const renderInputStyles = makeStyles(theme => ({
  input: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: '2px solid',
        borderRadius: '10px',
        borderColor: theme.palette.common.tealish,
      },
      '& input': {
        margin: '8px 0 8px 4px',
        fontSize: '16px'
      },
      '& .MuiChip-label': {
        fontSize: '16px',
        lineHeight: '16px'
      },
      '& .MuiAutocomplete-tag': {
        height: '38px',
        borderRadius: '30px'
      },
    }
  },
  spinner: {
    padding: 5,
  },
}));

const renderInput = (placeholder, loading=false, params) => {
  const classes = renderInputStyles();

  return (
    <Box display="flex" alignItems="center" >
      <Box flexGrow={1}>
        <TextField
          className={classes.input}
          {...params}
          placeholder={placeholder}
          variant="outlined"
        />
      </Box>
      {loading && (
        <Box className={classes.spinner}>
          <CircularProgress size={20} thickness={5}/>
        </Box>
      )}
    </Box>
  );
};

const LocationSearchBox = ({ title, selectedValue, onSearchChange, inputRenderer=renderInput }) => {
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [value, setValue] = useState(selectedValue ? selectedValue : null);
  const [focus, setFocus] = useState(false);

  const open = focus && (options.length > 1 || (options.length === 1 && value !== inputValue));

  useEffect(() => {
    if (inputValue.length < 2) return;
    setLoading(true);
    ProviderAPI.locationAutocomplete(inputValue).then(r => {
      setOptions(r.payload);
      setLoading(false);
    });
  }, [inputValue]);

  useEffect(() => {
    onSearchChange(value);
  }, [value]);  // eslint-disable-line react-hooks/exhaustive-deps

  const onLocationClick = location => {
    setValue(location);
  };

  return (
    <>
      <Typography variant="h3" className={classes.title}>{title}</Typography>
      <Autocomplete
        options={options}
        open={open}
        autoComplete
        autoHighlight
        filterSelectedOptions
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        onChange={(event, value) => {
          setValue(value);
        }}
        popupIcon={null}
        value={value}
        renderInput={params => inputRenderer('Enter a suburb or postcode', loading, params)}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
      />
      <UseMyLocation className={classes.useMyLocation} onSuccess={onLocationClick} />
    </>
  );
};

LocationSearchBox.propTypes = {
  title: PropTypes.string,
  selectedValue: PropTypes.string,
  onSearchChange: PropTypes.func,
  inputRenderer: PropTypes.func,
};

export default LocationSearchBox;